import { Icon, Icons } from '@clientbase/clientbase-library'

interface GradientOpenWithIconProps {
  width: string
  height: string
  colors: any[]
  icon?: Icons
}

export const GradientOpenWithIcon = ({
  colors,
  height,
  width,
  icon
}: GradientOpenWithIconProps) => {
  // Use a default icon if icon is undefined, null, empty string, or invalid
  const validIcon: Icons = icon && icon.trim() !== '' ? icon : 'helpOutline'

  return (
    <>
      <svg width={0} height={0}>
        <linearGradient id="linearColors" x1={1} y1={0} x2={1} y2={1}>
          {colors.map((color, index) => (
            <stop key={index} offset={index} stopColor={color} />
          ))}
        </linearGradient>
      </svg>
      <Icon
        icon={validIcon}
        width={width}
        height={height}
        sx={{
          '& path': {
            fill: 'url(#linearColors)'
          },
          '& svg[data-icon]': {
            fill: 'url(#linearColors)'
          },
          width,
          height
        }}
      />
    </>
  )
}
